import { RootDispatch } from "../types";
import history from "../../history";
import env from "../../utils/env";
import { post } from "../../utils/fetch";
import { fetchCurrentUser } from "../session/actions";

export type Action =
  | { type: "signin/signin-started"; username: string; password: string }
  | { type: "signin/signin-success"; token: string }
  | { type: "signin/signin-failure"; errorMessage: string | null }
  | { type: "signin/logout-started" }
  | { type: "signin/logout-success" }
  | { type: "signin/logout-failure" };

export const tokenSignin = (username: string, password: string) => async (
  dispatch: RootDispatch
) => {
  dispatch({
    type: "signin/signin-started",
    username: username,
    password: password
  });

  const body = { username: username, password: password };
  const headers = { Accept: "application/json" };

  const resp = await post<{ token: string }>("api-token-auth/", body, { headers });

  if (resp.error) {
    dispatch({
      type: "signin/signin-failure",
      errorMessage: resp.error.message
    });
  } else if (resp.data) {
    localStorage.setItem(`covid-user`, resp.data.token);
    dispatch({
      type: "signin/signin-success",
      token: resp.data.token
    });
    history.push("/dashboard/");
  }
};

/* Sign in, receive session cookie. No storage required. */
export const signin = (username: string, password: string) => async (dispatch: RootDispatch) => {
  const body = { username: username, password: password };
  const headers = {
    Accept: "application/json"
  };

  const resp = await post<{ success: boolean }>("api/login/", body, { headers });

  if (resp.error) {
    dispatch({
      type: "signin/signin-failure",
      errorMessage: "Invalid username or password"
    });
  } else if (resp.data?.success) {
    dispatch(fetchCurrentUser());
  } else {
    // TODO Logging
  }
};

/* Sign out. clear session */
export const signout = () => async (_dispatch: RootDispatch) => {
  window.location.assign(env.PROJECT19_API_ROOT.replace(/\/$/, "") + "/api/logout/");
};
